// extracted by mini-css-extract-plugin
export default {"menu":"t8_arTjqEF","list":"IUVCMVX4tN","item":"smY4DHwXYv"};